var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, InputBase, MenuItem, Paper, } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import cx from 'clsx';
import { Emphasize } from '../Emphasize';
function CustomTextField(_a) {
    var InputProps = _a.InputProps;
    return (_jsxs(Paper, { className: cx('faq-search'), elevation: 1, children: [_jsx(InputBase, __assign({ className: "faq-search__input" }, InputProps)), _jsx(IconButton, { className: cx('faq-search-button', 'faq-search__icon-button'), "aria-label": "Search", type: "submit", children: _jsx(SearchIcon, { className: "faq-search-icon", fontSize: "large", component: function (svgProps) { return (_jsxs("svg", __assign({}, svgProps, { children: [_jsx("defs", { children: _jsxs("linearGradient", { id: "faq-search-gradient", children: [_jsx("stop", { offset: "0" }), _jsx("stop", { offset: "1" })] }) }), svgProps.children] }))); } }) })] }));
}
export function renderInput(inputProps) {
    return _jsx(CustomTextField, { InputProps: inputProps.InputProps });
}
export function renderSuggestion(_a) {
    var suggestion = _a.suggestion, index = _a.index, itemProps = _a.itemProps, highlightedIndex = _a.highlightedIndex, inputValue = _a.inputValue, onClick = _a.onClick;
    var isHighlighted = highlightedIndex === index;
    // const isSelected = (selectedItem || '').indexOf(suggestion.title) > -1
    var handleClick = function (e) {
        e.preventDefault();
        onClick(suggestion, { inputValue: inputValue });
    };
    var _b = itemProps, isSelected = _b.isSelected, props = __rest(_b, ["isSelected"]);
    return (_createElement(MenuItem, __assign({}, props, { classes: { selected: 'faq-search-item--selected' }, key: suggestion.id, selected: isHighlighted, component: "div", style: {
            fontWeight: isSelected ? 500 : 400,
        }, onClick: handleClick }),
        _jsx(Emphasize, { target: suggestion.title })));
}
//# sourceMappingURL=renderer.js.map